import React from 'react';
import styled from 'styled-components';
import UnitCardName from './UnitCardName';

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #f7f6f4;
  height: 50px;
  font-size: 16px;
  padding-top: 12px;
  flex: 0 0 auto;
  padding-right: 15px;

  .template-name {
    text-align: left;
    padding-left: 15px;
    width: 50%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .template-date {
    padding-top: 2px;
  }

  .button-full-screen {
    border: 1px solid transparent;
    background-color: transparent;
  }

  .template-info {
    border: 0;
    display: flex;
    flex-direction: row;
    padding-top: 2px;
    padding-right: 0;
  }
`;

const UnitCardHeader = ({ children, unit }) => (
  <StyledHeader>
    <UnitCardName className="template-name" name={unit.name} />
    <div className="template-info">{children}</div>
  </StyledHeader>
);

export default UnitCardHeader;
